import { useEffect, useMemo } from "react";

import { isProd } from "../../shared/constants";
import { type ApolloResult } from "../../shared/models";
import { getEntries, mapRecord } from "../../shared/utils/object";
import { type CofFeatureGateResult, type CofFeatureGateResultMap } from "../models";

import { useCofConfigs } from "./useCofConfigs";
import { useLogAbExposure } from "./useLogAbExposure";

export const useFeatureGates = (): ApolloResult<{ configs: CofFeatureGateResultMap }> => {
    const logExposure = useLogAbExposure();

    const { loading, error, configs } = useCofConfigs();

    useEffect(() => {
        if (!isProd()) {
            return;
        }
        for (const [_, { shouldLogExposure, studyName, experimentId }] of getEntries(configs)) {
            if (shouldLogExposure) {
                void logExposure({ studyName, treatmentId: experimentId });
            }
        }
    }, [configs, logExposure]);

    const featureGateConfigs = useMemo(
        () =>
            mapRecord(configs, (_, cofConfig): CofFeatureGateResult => {
                return { ...cofConfig, enabled: !!cofConfig.value?.boolValue };
            }),
        [configs],
    );

    return {
        loading,
        error,
        configs: featureGateConfigs,
    };
};
